import { Vocabulary } from "../Vocabulary";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DescriptionIcon from "@mui/icons-material/Description";

export const ROUTER_DOCUMENTE_FINANCIARE = {
  routes: [
    "/",
    "/vehiclesDashboard",
    "/vehiclesDashboard/vehicleDocuments/:id?",
    "/documents",
    "*",
  ],
};

export const MAIN_SLIDER_DOCUMENTE = [
  {
    name: Vocabulary.documents,
    path: "/documents",
    icon: <DescriptionIcon />,
    orderId: 5,
  },
];

export const VEHICLE_OPTIONS_DOCUMENTE_FINANCIARE = [
  {
    name: Vocabulary.documente,
    path: "/vehiclesDashboard/vehicleDocuments/",
    icon: <FileCopyIcon />,
    id: "vehicleDocuments",
    slug: "vehicleDocuments",
    orderNumber: 7,
  },
];

export const DINAMIC_TABS_DOCUMENTE_FINANCIARE = null;

export const MAIN_TABLE_DOCUMENTE_FINANCIARE = null;

export const VEHICLE_MAIN_INFO = {
  accesToDocuments: true,
};
